import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {useValidateSSOMutation} from '../../features/authentication/authApiSlice';
import { setCredentials } from '../../features/authentication/authSlice';
import { useDispatch } from 'react-redux';

export default function Index() {
  const navigate = useNavigate();
  const [validateSSO] = useValidateSSOMutation();
  const dispatch = useDispatch();
  const ValidateSSOAsync = async() => {
    try {
      const authResponse = await validateSSO().unwrap();
      if(authResponse?.isSuccess){
        dispatch(
          setCredentials({
            accessToken: authResponse.accessToken
          })
        );
        navigate('/dashboard');
        return;
      }
      
      navigate('/login', {
        state: { nycSsoResponse: authResponse?.reason},
      });

    } catch (ex) {
      console.log('Exception',ex);
      navigate('/login');
    }
  };

  useEffect(() => {
    ValidateSSOAsync(); 
  }, []);

  return (
    <>Redirecting...</>
  );
}
